import { type ICallEventData } from '@/types/ICallEvent';
import { isCallAccount } from './isCallAccount';
import { isRecord } from './isRecord';

/**
 * Type guard полезной нагрузки звонка. Общий для живого и исторического
 * события — форма `data` у них одинаковая.
 *
 * @param value - произвольное значение (поле `data` события)
 * @returns `true`, если значение соответствует форме `ICallEventData`
 */
export const isCallEventData = (value: unknown): value is ICallEventData =>
  isRecord(value) &&
  typeof value.incoming_phone === 'string' &&
  (value.user === null || isCallAccount(value.user));
